import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { AudioProcessor } from "./audioProcessor";

export const useAudioStore = defineStore("audio", () => {
  const audioProcessor = ref<AudioProcessor>(new AudioProcessor());
  const isCapturing = ref(false);
  const hasPermission = ref(false);
  const currentRMS = ref(0);
  const error = ref<string | null>(null);

  const isListening = computed(() => isCapturing.value && hasPermission.value);

  async function startCapture(): Promise<void> {
    try {
      error.value = null;
      await audioProcessor.value.startCapture();
      isCapturing.value = true;
      hasPermission.value = true;

      const interval = setInterval(() => {
        if (!isCapturing.value) {
          clearInterval(interval);
          return;
        }
        currentRMS.value = audioProcessor.value.getCurrentRMS();
      }, 100);
    } catch (err) {
      error.value = err instanceof Error ? err.message : "Неизвестная ошибка";
      isCapturing.value = false;
      hasPermission.value = false;
      throw err;
    }
  }

  function stopCapture(): void {
    try {
      audioProcessor.value.stopCapture();
      isCapturing.value = false;
      currentRMS.value = 0;
      error.value = null;
    } catch (err) {
      error.value = err instanceof Error ? err.message : "Неизвестная ошибка";
    }
  }

  async function requestPermission(): Promise<boolean> {
    try {
      await audioProcessor.value.startCapture();
      audioProcessor.value.stopCapture();
      hasPermission.value = true;
      error.value = null;
      return true;
    } catch (err) {
      error.value = err instanceof Error ? err.message : "Неизвестная ошибка";
      hasPermission.value = false;
      return false;
    }
  }

  function clearError(): void {
    error.value = null;
  }

  return {
    audioProcessor,
    isCapturing,
    hasPermission,
    currentRMS,
    error,
    isListening,
    startCapture,
    stopCapture,
    requestPermission,
    clearError,
  };
});
